import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Stack, Typography, } from '@mui/material';
import CheckIcon from '@mui/icons-material/CheckOutlined';
import CameraswitchIcon from '@mui/icons-material/CameraswitchOutlined';
import Card from '@ui-lib/components/Card';

interface Props {
    handleModalStateChange: () => void;
}

const QrScanned = ({ handleModalStateChange }: Props) => {
  const { t } = useTranslation();

  return <Card testID='qr-field'>
    <Stack alignItems='center' spacing={1} pt={6} pb={6}>
      <CheckIcon color='success' fontSize='large' />
      <Typography variant='subtitle2Bold' gutterBottom textAlign='center'>
        {t('bolCreatePage_qrScannedSuccessfully')}
      </Typography>
    </Stack>
    <Button
      variant='tonal'
      fullWidth
      onClick={handleModalStateChange}
      startIcon={<CameraswitchIcon />}
    >
      {t('bolCreatePage_scanAgain')}
    </Button>
  </Card>;
};

export default QrScanned;